import type { MisconceptionDefinition } from '../types';
export const GELD_TELLEN: MisconceptionDefinition[] = [{
  id: 'geld.cent-als-decimaal-verward',
  label: 'Verwart cent-notatie met decimale notatie',
  module: 'Geld',
  description: 'Leerling schrijft 70 cent als ,07 of 5 cent als ,50 — verwart aantal centen met decimale positie.',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.munt-vergeten',
  label: 'Vergeet een munt mee te tellen',
  module: 'Geld',
  description: 'Leerling slaat één van de getoonde munten over bij het optellen.',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.optel-fout',
  label: 'Maakt rekenfout bij optellen van centen',
  module: 'Geld',
  description: 'Leerling maakt een eenvoudige optelfout (bijv. 50 + 20 = 72).',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.afronden-naar-50',
  label: 'Rondt centen onterecht af naar 50',
  module: 'Geld',
  description: 'Leerling rondt 35 cent af naar 50 cent (denkt dat alleen 50/100 cent bedragen bestaan).',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.euro-als-1000',
  label: 'Denkt dat 1 euro = 1000 cent',
  module: 'Geld',
  description: 'Leerling verwart 1 euro met 1000 cent (i.p.v. 100 cent) — vermoedelijk verwarring met meter/kilometer.',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.euro-vergeten',
  label: 'Vergeet de euro mee te tellen',
  module: 'Geld',
  description: 'Leerling geeft alleen het cent-deel terug en vergeet het euro-deel (€1,35 → 35 cent).',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.muntwaarde-onbekend',
  label: 'Denkt dat er een niet-bestaande munt is',
  module: 'Geld',
  description: 'Leerling gebruikt een muntwaarde die niet bestaat (bijv. 30-centmunt). De munten zijn: 1, 2, 5, 10, 20, 50 cent en €1, €2.',
  typicalFamilies: ['GELD-TELLEN', 'GELD-MAAK']
}, {
  id: 'geld.niet-min-munten',
  label: 'Gebruikt niet het minimaal aantal munten',
  module: 'Geld',
  description: 'Leerling kiest een correcte muntcombinatie qua bedrag, maar gebruikt te veel munten (bijv. 17 × 5 cent voor 85 cent).',
  typicalFamilies: ['GELD-TELLEN', 'GELD-MAAK']
}, {
  id: 'geld.aantal-genegeerd',
  label: 'Telt aantal munten/biljetten niet mee',
  module: 'Geld',
  description: 'Leerling telt 2 × €1 als €1 — negeert het aantal en telt elke muntsoort maar één keer.',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.halve-fout',
  label: 'Maakt fout bij vermenigvuldigen met 50 cent',
  module: 'Geld',
  description: "Leerling rekent 3 × 50 cent als €2 i.p.v. €1,50 — moeite met halve euro's.",
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.halve-munten-vergeten',
  label: 'Vergeet 50-centmunten mee te tellen',
  module: 'Geld',
  description: 'Leerling slaat de 50-centmunten over bij het optellen, mogelijk omdat ze "minder dan een euro" zijn.',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.aantal-onjuist',
  label: 'Gebruikt verkeerd aantal bij vermenigvuldigen',
  module: 'Geld',
  description: 'Leerling vermenigvuldigt met het verkeerde aantal munten/biljetten (telt 2 als 3 of vice versa).',
  typicalFamilies: ['GELD-TELLEN']
}, {
  id: 'geld.overdraag-vergeten',
  label: 'Vergeet overdracht bij optelling van centen',
  module: 'Geld',
  description: 'Leerling vergeet dat 100 cent = 1 euro overdracht is bij het optellen van centenbedragen.',
  typicalFamilies: ['GELD-TELLEN', 'GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-centen-optelfout',
  label: 'Telt centen verkeerd op bij boodschappen',
  module: 'Geld',
  description: 'Leerling maakt rekenfout bij het optellen van cent-delen (bijv. 45+10+25=70 i.p.v. 80).',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-overdracht-fout',
  label: 'Onterechte overdracht bij optelling',
  module: 'Geld',
  description: 'Leerling telt een overdracht mee terwijl de centen onder 100 blijven (8,80 → denkt aan 7 euro).',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-bedrag-overgeslagen',
  label: 'Slaat een bedrag over bij optellen',
  module: 'Geld',
  description: 'Leerling vergeet één van de boodschappenposten mee te tellen.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-centen-aftrekfout',
  label: 'Aftrekfout bij wisselgeld met centen',
  module: 'Geld',
  description: 'Leerling maakt aftrekfout bij wisselgeld (bijv. 100 − 64 = 46 i.p.v. 36).',
  typicalFamilies: ['GELD-BOODSCHAPPEN', 'GELD-TERUG', 'GELD-TERUGREKENEN']
}, {
  id: 'geld.boodschappen-optelling-fout',
  label: 'Maakt optelfout bij boodschappen-totaal',
  module: 'Geld',
  description: 'Leerling telt de boodschappenbedragen verkeerd op (€2,75 + €1,89 = €5,64 i.p.v. €4,64).',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-bedrag-vergeten',
  label: 'Vergeet een bedrag bij optelling boodschappen',
  module: 'Geld',
  description: 'Leerling laat een artikel weg bij het totaal — vaak het laagste of het eerste bedrag.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-keer-afrond',
  label: 'Rondt vermenigvuldiging onterecht af',
  module: 'Geld',
  description: 'Leerling rondt 35×6 af naar 200 in plaats van precies 210 te rekenen.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-prijs-verkeerd-gelezen',
  label: 'Leest prijs verkeerd af (te laag)',
  module: 'Geld',
  description: 'Leerling leest €0,30 in plaats van €0,35 (of vergelijkbaar) — rondt of negeert het laatste cijfer.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-prijs-verkeerd-gelezen-2',
  label: 'Leest prijs verkeerd af (te hoog)',
  module: 'Geld',
  description: 'Leerling leest €0,40 in plaats van €0,35 (of vergelijkbaar) — rondt naar boven of leest verkeerd cijfer.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-keer-centen-fout',
  label: 'Rekenfout bij vermenigvuldigen met centen',
  module: 'Geld',
  description: 'Leerling rekent 3×49 als 153 i.p.v. 147 — typische 9-times-table fout.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-vergeet-vermenigvuldigen',
  label: 'Vergeet te vermenigvuldigen met aantal',
  module: 'Geld',
  description: 'Leerling rekent met de prijs van 1 stuk in plaats van met het aantal te vermenigvuldigen.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}, {
  id: 'geld.boodschappen-afronding-fout',
  label: 'Schat product onterecht in als bijna gelijk aan budget',
  module: 'Geld',
  description: 'Leerling schat 3 × €1,49 als ongeveer €5,00, waardoor het wisselgeld extreem laag wordt geschat.',
  typicalFamilies: ['GELD-BOODSCHAPPEN']
}];